module.exports = __webpack_public_path__ + "static/media/map-hi-pin.b91b6832.png";